import React from "react";

import { Icon as SemanticIcon, Header, Card, Button } from "semantic-ui-react";

import Icon from "../../../components/Icon/.";

const TestCards = [
  {
    last4: "7393",
    brand: "American Express",
    name: "Jason Bourne",
    exp_month: 1,
    exp_year: 2022,
    funding: "debit",
    status: "active"
  },
  {
    last4: "5234",
    brand: "MasterCard",
    name: "Jack Serrino",
    exp_month: 1,
    exp_year: 2022,
    funding: "credit",
    status: "inactive"
  },
  {
    last4: "8223",
    brand: "UnionPay",
    name: "Jack Serrino",
    exp_month: 1,
    exp_year: 2022,
    funding: "prepaid",
    status: "error"
  }
];

const cardBrandToIcon = {
  "American Express": "cc amex",
  Visa: "cc visa",
  MasterCard: "cc mastercard",
  JCB: "cc jcb",
  "Diners Club": "cc diners club",
  Discover: "cc discover"
};

const CreditCard = props => {
  const card = props.card;
  const color =
    card.status === "active"
      ? "green"
      : card.status === "error"
        ? "red"
        : "grey";
  const icon =
    card.status === "active"
      ? "check"
      : card.status === "error"
        ? "times"
        : "pause";
  return (
    <Card color={color}>
      <Card.Content>
        <Card.Header>**** **** **** {card.last4}</Card.Header>
        <Card.Meta>
          <span style={{ textTransform: "capitalize" }}>{card.funding},</span>
          {card.brand} &nbsp;
          <SemanticIcon name={cardBrandToIcon[card.brand] || "credit card"} />
        </Card.Meta>
        <Card.Description>
          {card.name}, {card.exp_month}/{card.exp_year}
        </Card.Description>
      </Card.Content>
      <Card.Content extra style={{ textTransform: "capitalize" }}>
        <SemanticIcon name={icon} color={color} />{" "}
        {card.status !== "error" ? card.status : "Problem"}
      </Card.Content>
    </Card>
  );
};

const BillingSettingsView = () => {
  return (
    <div>
      <Header dividing as="h4">
        Your billing information
      </Header>
      <Card.Group>
        {TestCards.map((card, i) => <CreditCard card={card} key={i} />)}
      </Card.Group>
      <div style={{ marginTop: "1em" }}>
        <Button icon labelPosition="left" primary>
          <SemanticIcon name="plus" />Add another card
        </Button>
      </div>
      <Header dividing as="h4">
        Your <Icon icon="spout" /> Spout plan
      </Header>
      <div>Spout plans go here.</div>
      <Header dividing as="h4" id="addons">
        <Icon icon="spout" /> Spout Add-ons
      </Header>
      <div>Spout add-ons go here.</div>
    </div>
  );
};

export default BillingSettingsView;



// WEBPACK FOOTER //
// ./frontend/src/views/pages/settings/BillingSettingsView.js